
export const apiUrl = 'https://immo-wiin.com';
// export const apiUrl = 'http://dev.immowiin';


// export const apiCreditWiinUrl = 'http://dev.apicourtizen';
export const apiCreditWiinUrl = "https://apiv1.2l-courtage.com/";